import { z } from 'zod';
import { itemSchema } from './item/item-dto';

export const loopViewItemsResponseSchema = z.object({
  items: z.array(itemSchema),
});

export type LoopViewItemsResponseDTO = z.infer<typeof loopViewItemsResponseSchema>;
